import { createBlueprint as t } from "@made-people/blueprint";
const n = t({
  slots: {
    base: ""
  },
  variants: {}
}), r = t({
  slots: {
    contentWrapper: "p-4 bg-white flex flex-col",
    text: "text-label-md",
    heading: "text-heading-md font-medium"
  },
  variants: {}
});
export {
  r as notifyMeDrawerBlueprint,
  n as notifyMeFormBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
